import { useId } from 'react';

/**
 * Background pattern presets for organization sites (docs/Decisions.md D43).
 * Drawn as SVG in `currentColor`, so the colour comes from a design-system
 * utility on the wrapper (`text-z-line`, which a site palette re-themes),
 * not from a literal. Decorative only: hidden from assistive technology.
 */
const SHAPES = {
  dots: { size: 18, render: () => <circle cx="3" cy="3" r="1.6" fill="currentColor" /> },
  grid: {
    size: 24,
    render: () => <path d="M24 0H0V24" fill="none" stroke="currentColor" strokeWidth="1" />,
  },
  diagonal: {
    size: 14,
    render: () => (
      <path d="M-2 16L16 -2M12 16L16 12M-2 2L2 -2" stroke="currentColor" strokeWidth="1.2" />
    ),
  },
  waves: {
    size: 40,
    render: () => (
      <path d="M0 20 Q10 10 20 20 T40 20" fill="none" stroke="currentColor" strokeWidth="1.2" />
    ),
  },
};

export const PATTERN_IDS = ['none', 'dots', 'grid', 'diagonal', 'waves'];

export default function SitePattern({ pattern, className = '' }) {
  const id = useId().replace(/:/g, '');
  const shape = SHAPES[pattern];
  if (!shape) return null;
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      className={`pointer-events-none absolute inset-0 size-full text-z-line ${className}`}
    >
      <defs>
        <pattern
          id={`site-pattern-${id}`}
          width={shape.size}
          height={shape.size}
          patternUnits="userSpaceOnUse"
        >
          {shape.render()}
        </pattern>
      </defs>
      <rect width="100%" height="100%" fill={`url(#site-pattern-${id})`} />
    </svg>
  );
}
